/**
 * cart-datetime-picker.js  v8
 * Kudil Theme — Delivery Date & Time Gate
 *
 * CHANGE from v7:
 *   Native checkout button stays VISIBLE.
 *   Clicking it without date+time selected shows inline error,
 *   shakes the fields, and blocks navigation.
 *   Once both fields are filled it proceeds normally.
 *
 * INSTALL:
 *   1. Upload to Assets as: cart-datetime-picker.js
 *   2. Add to theme.liquid just before </body>:
 *      <script src="{{ 'cart-datetime-picker.js' | asset_url }}" defer></script>
 */

(function () {
  'use strict';

  /* ═══════════════════════════
     CONFIG
  ═══════════════════════════ */
  var CONFIG = {
    timeSlots: [
      '11:00 AM – 12:00 PM',
      '12:00 PM – 1:00 PM',
      '1:00 PM – 2:00 PM',
      '3:00 PM – 4:00 PM',
      '5:00 PM – 6:00 PM',
      '6:00 PM – 7:00 PM',
      '7:00 PM – 8:00 PM',
      '8:00 PM – 9:00 PM',
      '9:00 PM – 10:00 PM'
    ],
    maxDaysAhead : 7,
    closedDays   : [],   /* 0=Sun 1=Mon 2=Tue 3=Wed 4=Thu 5=Fri 6=Sat */
    headingText  : 'Schedule Your Delivery',
    dateLabel    : 'Delivery Date',
    timeLabel    : 'Delivery Time Slot',
    errorMsg     : '⚠️ Please select a delivery date and time before checkout.'
  };

  var IS_CART_PAGE = window.location.pathname === '/cart';

  /* ── helpers ── */
  function todayStr() {
    var d = new Date();
    return d.getFullYear() + '-' +
      String(d.getMonth()+1).padStart(2,'0') + '-' +
      String(d.getDate()).padStart(2,'0');
  }
  function maxDateStr() {
    var d = new Date();
    d.setDate(d.getDate() + CONFIG.maxDaysAhead);
    return d.getFullYear() + '-' +
      String(d.getMonth()+1).padStart(2,'0') + '-' +
      String(d.getDate()).padStart(2,'0');
  }
  function niceDate(val) {
    var d = new Date(val + 'T00:00:00');
    var days   = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
    var months = ['Jan','Feb','Mar','Apr','May','Jun',
                  'Jul','Aug','Sep','Oct','Nov','Dec'];
    return days[d.getDay()] + ', ' + d.getDate() + ' ' +
           months[d.getMonth()] + ' ' + d.getFullYear();
  }

  /* ════════
     CSS
  ════════ */
  var CSS = `
    .cdp-wrap { box-sizing:border-box; width:100%; }

    /* ── drawer panel ── */
    .cdp-wrap.cdp-drawer .cdp-panel {
      padding: 14px 16px 16px;
      background: linear-gradient(135deg,#1a1008 0%,#251608 55%,#1e1206 100%);
      border-top: 1px solid rgba(175,140,88,.22);
      border-bottom: 1px solid rgba(175,140,88,.18);
      position: relative;
      margin-bottom: 12px;
    }

    /* ── cart page panel ── */
    .cdp-wrap.cdp-page .cdp-panel {
      padding: 20px 22px;
      background: linear-gradient(135deg,#1a1008 0%,#251608 55%,#1e1206 100%);
      border: 1px solid rgba(175,140,88,.28);
      border-radius: 14px;
      box-shadow: 0 6px 28px rgba(0,0,0,.28);
      position: relative;
      margin-bottom: 14px;
    }

    /* gold shimmer line */
    .cdp-panel::before {
      content:''; position:absolute; inset:0 0 auto 0; height:1px;
      background: linear-gradient(90deg,transparent,rgba(175,140,88,.6),transparent);
      pointer-events:none;
    }

    .cdp-heading {
      font-size:11px; font-weight:700; letter-spacing:1.2px;
      text-transform:uppercase; color:#c9a96e;
      display:flex; align-items:center; gap:7px; margin:0 0 12px;
    }
    .cdp-heading svg { flex-shrink:0; }

    .cdp-row { display:flex; gap:10px; }
    @media(max-width:520px) { .cdp-row { flex-direction:column; } }

    .cdp-field { flex:1; display:flex; flex-direction:column; gap:5px; }
    .cdp-label {
      font-size:10px; font-weight:700; letter-spacing:.9px;
      text-transform:uppercase; color:rgba(245,220,170,.5);
    }
    .cdp-req { color:#c9a96e; }

    .cdp-input {
      width:100%; padding:8px 10px;
      background:rgba(0,0,0,.45);
      border:1px solid rgba(175,140,88,.22);
      border-radius:8px; color:#f5e6c8;
      font-size:13px; font-family:inherit;
      box-sizing:border-box;
      appearance:none; -webkit-appearance:none;
      transition: border-color .18s, box-shadow .18s;
    }
    .cdp-input:focus {
      outline:none;
      border-color:rgba(175,140,88,.6);
      box-shadow:0 0 0 3px rgba(175,140,88,.12);
    }
    .cdp-input::placeholder { color:rgba(245,220,170,.25); }
    .cdp-input::-webkit-calendar-picker-indicator {
      filter:invert(.65) sepia(1) hue-rotate(10deg); cursor:pointer;
    }
    .cdp-input option { background:#1a1008; color:#f5e6c8; }

    /* field-level error border */
    .cdp-input.cdp-field-error {
      border-color: rgba(239,68,68,.7) !important;
      box-shadow: 0 0 0 3px rgba(239,68,68,.15) !important;
    }

    .cdp-hint { font-size:10px; color:#f87171; margin-top:4px; display:none; }
    .cdp-hint.show { display:block; }

    .cdp-shake { animation:cdp-shake .38s ease; }
    @keyframes cdp-shake {
      0%,100% { transform:translateX(0) }
      20%     { transform:translateX(-6px) }
      40%     { transform:translateX(6px) }
      60%     { transform:translateX(-4px) }
      80%     { transform:translateX(4px) }
    }

    /* ── inline error banner — shown above checkout button ── */
    .cdp-error-banner {
      display: none;
      align-items: center;
      gap: 10px;
      padding: 11px 14px;
      margin-bottom: 10px;
      background: rgba(239,68,68,.12);
      border: 1px solid #ff0000;
      border-radius: 10px;
      font-size: 12px;
      font-weight: 600;
      color: #ff0000;
      animation: cdp-fadein .2s ease;
    }
    .cdp-error-banner.show { display:flex; }
    .cdp-error-banner svg { flex-shrink:0; width:15px; height:15px; color:#f87171; }
    @keyframes cdp-fadein {
      from { opacity:0; transform:translateY(-4px); }
      to   { opacity:1; transform:translateY(0); }
    }
  `;

  function injectStyles() {
    if (document.getElementById('cdp-styles')) return;
    var s = document.createElement('style');
    s.id = 'cdp-styles'; s.textContent = CSS;
    document.head.appendChild(s);
  }

  /* ═══════════
     HTML
     (panel only — no replacement checkout button)
  ═══════════ */
  function buildHTML() {
    var opts = CONFIG.timeSlots.map(function(s){
      return '<option value="'+s+'">'+s+'</option>';
    }).join('');
    return [
      /* error banner — sits above the native checkout button */
      '<div class="cdp-error-banner" id="cdp-error-banner">',
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">',
          '<circle cx="12" cy="12" r="10"/>',
          '<line x1="12" y1="8" x2="12" y2="12"/>',
          '<line x1="12" y1="16" x2="12.01" y2="16"/>',
        '</svg>',
        '<span>'+CONFIG.errorMsg+'</span>',
      '</div>',

      /* date + time panel */
      '<div class="cdp-panel">',
        '<p class="cdp-heading">',
          '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">',
            '<rect x="3" y="4" width="18" height="18" rx="2"/>',
            '<path d="M16 2v4M8 2v4M3 10h18"/>',
          '</svg>',
          CONFIG.headingText,
        '</p>',
        '<div class="cdp-row">',
          '<div class="cdp-field">',
            '<span class="cdp-label">'+CONFIG.dateLabel+' <span class="cdp-req">*</span></span>',
            '<input type="date" class="cdp-input cdp-date"',
            ' min="'+todayStr()+'" max="'+maxDateStr()+'" autocomplete="off">',
            '<span class="cdp-hint cdp-date-hint">Please pick a delivery date.</span>',
          '</div>',
          '<div class="cdp-field">',
            '<span class="cdp-label">'+CONFIG.timeLabel+' <span class="cdp-req">*</span></span>',
            '<select class="cdp-input cdp-time">',
              '<option value="">Choose a slot…</option>',
              opts,
            '</select>',
            '<span class="cdp-hint cdp-time-hint">Please pick a time slot.</span>',
          '</div>',
        '</div>',
      '</div>'
    ].join('');
  }

  /* ═══════════════════════════════════
     ATTACH LOGIC TO A WRAP + its button
     btn = the NATIVE checkout button
  ═══════════════════════════════════ */
  function attachLogic(wrap, nativeBtn) {
    var dateEl  = wrap.querySelector('.cdp-date');
    var timeEl  = wrap.querySelector('.cdp-time');
    var dHint   = wrap.querySelector('.cdp-date-hint');
    var tHint   = wrap.querySelector('.cdp-time-hint');
    var banner  = wrap.querySelector('.cdp-error-banner');
    if (!dateEl || !nativeBtn) return;

    function shake(el) {
      el.classList.add('cdp-shake');
      setTimeout(function(){ el.classList.remove('cdp-shake'); }, 400);
    }

    function isValid() {
      return dateEl.value !== '' && timeEl.value !== '';
    }

    function clearErrors() {
      dateEl.classList.remove('cdp-field-error');
      timeEl.classList.remove('cdp-field-error');
      dHint.classList.remove('show');
      tHint.classList.remove('show');
      if (banner) banner.classList.remove('show');
    }

    function showErrors() {
      if (!dateEl.value) {
        dateEl.classList.add('cdp-field-error');
        dHint.classList.add('show');
        shake(dateEl);
      }
      if (!timeEl.value) {
        timeEl.classList.add('cdp-field-error');
        tHint.classList.add('show');
        shake(timeEl);
      }
      if (banner) {
        banner.classList.add('show');
        /* scroll banner into view */
        banner.scrollIntoView({ behavior:'smooth', block:'nearest' });
      }
    }

    /* Clear error state as user fills fields */
    dateEl.addEventListener('change', function() {
      dateEl.classList.remove('cdp-field-error');
      dHint.classList.remove('show');

      /* closed day check */
      if (dateEl.value && CONFIG.closedDays.length) {
        var day = new Date(dateEl.value+'T00:00:00').getDay();
        if (CONFIG.closedDays.indexOf(day) !== -1) {
          dateEl.value = '';
          dateEl.classList.add('cdp-field-error');
          dHint.textContent = 'We are closed that day. Choose another.';
          dHint.classList.add('show');
          shake(dateEl);
          return;
        }
      }
      if (isValid() && banner) banner.classList.remove('show');
    });

    timeEl.addEventListener('change', function() {
      timeEl.classList.remove('cdp-field-error');
      tHint.classList.remove('show');
      if (isValid() && banner) banner.classList.remove('show');
    });

    /* ── Intercept the native checkout button click ── */
    nativeBtn.addEventListener('click', function(e) {
      if (isValid()) {
        /* Valid — save to cart then let the button do its thing */
        clearErrors();
        e.preventDefault();
        e.stopImmediatePropagation();

        fetch('/cart/update.js', {
          method:'POST',
          headers:{'Content-Type':'application/json'},
          body: JSON.stringify({
            note: 'Delivery Date: '+niceDate(dateEl.value)+'  |  Time: '+timeEl.value,
            attributes: {
              'Delivery Date': niceDate(dateEl.value),
              'Delivery Time': timeEl.value
            }
          })
        })
        .then(function(){ window.location.href='/checkout'; })
        .catch(function(){ window.location.href='/checkout'; });

      } else {
        /* Invalid — block and show errors */
        e.preventDefault();
        e.stopImmediatePropagation();
        showErrors();
      }
    }, true); /* useCapture=true so we fire before Shopify's own handler */
  }

  /* ══════════════════════════════════════════════════════
     DRAWER INJECTION
     Inserts panel ABOVE the native checkout button.
     Native button stays visible and clickable.
  ══════════════════════════════════════════════════════ */
  function injectDrawer() {
    var checkoutBtn = document.getElementById('CartDrawer-Checkout');
    if (!checkoutBtn) return;

    var parent = checkoutBtn.parentNode;
    if (parent.querySelector('.cdp-wrap')) return;

    var wrap = document.createElement('div');
    wrap.className = 'cdp-wrap cdp-drawer';
    wrap.innerHTML = buildHTML();

    /* Insert wrap directly before the checkout button */
    parent.insertBefore(wrap, checkoutBtn);

    attachLogic(wrap, checkoutBtn);
  }

  /* ══════════════════════════════════════════════════════
     CART PAGE INJECTION
     Inserts panel ABOVE the native checkout button.
     Native button + Apple/Google Pay stay visible.
  ══════════════════════════════════════════════════════ */
  function injectCartPage() {
    var checkoutBtn = document.getElementById('checkout');
    if (!checkoutBtn) return;

    var ctas = checkoutBtn.closest('.cart__ctas') || checkoutBtn.parentElement;
    if (ctas.querySelector('.cdp-wrap')) return;

    var wrap = document.createElement('div');
    wrap.className = 'cdp-wrap cdp-page';
    wrap.innerHTML = buildHTML();

    /* Insert before the checkout button — keep button visible below panel */
    ctas.insertBefore(wrap, checkoutBtn);

    attachLogic(wrap, checkoutBtn);

    /* Also intercept dynamic payment buttons (Apple Pay / Google Pay) */
    document.querySelectorAll(
      '.shopify-payment-button__button, ' +
      '[data-shopify="payment-button"] button'
    ).forEach(function(dynBtn) {
      dynBtn.addEventListener('click', function(e) {
        if (!wrap.querySelector('.cdp-date').value ||
            !wrap.querySelector('.cdp-time').value) {
          e.preventDefault();
          e.stopImmediatePropagation();
          wrap.querySelector('.cdp-error-banner').classList.add('show');
          if (!wrap.querySelector('.cdp-date').value) {
            wrap.querySelector('.cdp-date').classList.add('cdp-field-error');
            wrap.querySelector('.cdp-date-hint').classList.add('show');
          }
          if (!wrap.querySelector('.cdp-time').value) {
            wrap.querySelector('.cdp-time').classList.add('cdp-field-error');
            wrap.querySelector('.cdp-time-hint').classList.add('show');
          }
          wrap.scrollIntoView({ behavior:'smooth', block:'nearest' });
        }
      }, true);
    });
  }

  /* ════════════════════════════════
     OBSERVER + FETCH HOOK + EVENTS
  ════════════════════════════════ */
  var debTimer = null;
  function schedule() {
    clearTimeout(debTimer);
    debTimer = setTimeout(function(){
      IS_CART_PAGE ? injectCartPage() : injectDrawer();
    }, 80);
  }

  function startObserver() {
    var obs = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].target.id === 'cdp-styles') continue;
        schedule();
        return;
      }
    });
    obs.observe(document.body, {
      childList:true, subtree:true, attributes:true,
      attributeFilter:['class','open','inert','aria-hidden','style']
    });
  }

  function interceptFetch() {
    var orig = window.fetch;
    window.fetch = function() {
      var url = typeof arguments[0]==='string' ? arguments[0] : '';
      var p = orig.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        p.then(function(){
          setTimeout(schedule, 300);
          setTimeout(schedule, 800);
        });
      }
      return p;
    };
  }

  function bindEvents() {
    ['cart:open','cart:refresh','cart:updated','cart:item:change','theme:cart:add']
      .forEach(function(ev){
        document.addEventListener(ev, function(){ setTimeout(schedule, 120); });
      });
  }

  /* ═══════
     INIT
  ═══════ */
  function init() {
    injectStyles();
    if (IS_CART_PAGE) {
      injectCartPage();
      [200, 500, 1200].forEach(function(ms){
        setTimeout(injectCartPage, ms);
      });
    } else {
      injectDrawer();
    }
    startObserver();
    interceptFetch();
    bindEvents();
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

})();